import type React from 'react';

type Props = {
	activeIndex: number;
	totalItems: number;
};

/**
 * Renders one pagination dot per carousel card, per Figma node 614:63960: a wide rounded "pill"
 * for the active card, small hollow circles for the others. Purely decorative -- the underlying
 * carousel already exposes proper list/listitem semantics, so this is hidden from assistive tech
 * rather than duplicating that information.
 */
export const CardsPaginationDots: React.FC<Props> = ({ activeIndex, totalItems }) => {
	return (
		<div aria-hidden className="flex items-center gap-2 md:hidden" data-testid="cards-pagination-dots">
			{Array.from({ length: totalItems }, (_, index) => (
				<span
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					className={
						index === activeIndex
							? 'bg-typography-strong h-[5px] w-6 shrink-0 rounded-full'
							: 'border-typography-strong/40 h-[5px] w-[5px] shrink-0 rounded-full border'
					}
				/>
			))}
		</div>
	);
};
